import React from 'react'

import ConditionsForContributorsFR from './fr'
import ConditionsForContributorsEN from './en'
import ConditionsForContributorsIT from './it'
import ConditionsForContributorsES from './es'
import ConditionsForContributorsDE from './de'

function ConditionsForContributors({ locale }) {
  switch (locale) {
    case 'fr-FR':
      return <ConditionsForContributorsFR />
    case 'it-IT':
      return <ConditionsForContributorsIT />
    case 'es-ES':
      return <ConditionsForContributorsES />
    case 'de-DE':
      return <ConditionsForContributorsDE />
    case 'en-US':
    default:
      return <ConditionsForContributorsEN />
  }
}

export default ConditionsForContributors
